import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchBlendedSearchReport({ state }, { expBlendedReportData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.experianBlendedReport.fetchBlendedSearchReport
        }`,
        expBlendedReportData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  orderExpBlendedReport({ state }, { expBlendedReportData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.experianBlendedReport.orderExpBlendedReport
        }`,
        expBlendedReportData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchExpBlendedReportSummary({ state }, orderId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.experianBlendedReport.fetchExpBlendedReportSummary
        }/${orderId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  retryExperianBlendedReport({ state }, orderId) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.experianBlendedReport.retryExperianBlendedReport
        }/${orderId}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
